import { merge } from "lib/merge";
import { createStore } from "lib/store";
import React, { useState } from "react";
import { defaultFormContext, FormContext } from "./contexts";

export const Form = ({
    name = "",
    alwaysValidate = false,
    values = {},
    rules = {},
    onSubmit,
    onChange,
    children
}) => {
    const [form] = useState(
        createStore(
            merge(defaultFormContext, {
                name,
                alwaysValidate,
                values,
                rules,
                onSubmit: typeof onSubmit === "function" ? [onSubmit] : [],
                onChange: typeof onChange === "function" ? [onChange] : []
            })
        )
    );
    return <FormContext.Provider value={form}>{children}</FormContext.Provider>;
};
